import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
 #SIDE-MENU
\*------------------------------------ */
/**
 * 1) Menu that acts as a side navigation. This can collapse or expand depending on the use-case
 */
:host {
  display: block;
}

/**
 * Side menu within the web component wrapper
 * 1) Span the list item link background the entire width
 */
.cat-c-side-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  --cat-list-item-link-margin-inline-end: 0; /* 1 */
  --cat-list-item-link-padding-inline-end: calc(var(--size-base-unit) * 2);
  --cat-side-menu-after-top: -2px;
  --cat-side-menu-link-align-items: center;
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: calc(var(--size-base-unit) * 3);
  --cat-list-item-link-width: calc(100%);
  --cat-list-item-link-hover: var(--cat-theme-color-content-strong);
  --cat-list-item-link-strong-hover: var(--cat-theme-color-content-strong-hover);
  --cat-list-item-background-color: transparent;
  height: 100%;
  width: 100%;
}
.cat-c-side-menu:not(.cat-is-mobile) {
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: calc(var(--size-base-unit) * 7);
  --cat-list-item-link-padding-inline-end: calc(var(--size-base-unit) * 2.875);
  border-inline-end: 1px solid var(--cat-theme-color-border-default);
}
.cat-c-side-menu:not(.cat-is-collapsed) {
  --cat-list-item-link-marign-inline-start: 0;
  --cat-list-item-link-padding-inline-start: 0;
}
.cat-c-side-menu.cat-is-mobile {
  --cat-side-menu-link-padding-inline-start: calc(var(--size-base-unit) * 3);
  position: absolute;
  z-index: var(--cat-z-index-500);
}

/**
 * Side menu link
 */
.cat-c-side-menu__nav {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
  transition: width var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-side-menu:not(.cat-is-mobile) .cat-c-side-menu__nav {
  padding-inline: 0 0;
}

/**
 * Collapsed side menu
 * 1) List of custom properties used to pass down into side-menu items so user doesn't need
 * to apply isCollapsed to all items
 */
.cat-c-side-menu.cat-is-collapsed {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  /**
  * Collapsed side menu
  * will hide the side-menu on collapsed state in mobile view. 
  */
}
.cat-c-side-menu.cat-is-collapsed:not(.cat-is-mobile) {
  width: var(--cat-side-menu-collapse-width, 4.5rem);
  --cat-side-menu-text-white-space: nowrap;
  --cat-side-menu-text-text-overflow: ellipsis;
  --cat-side-menu-text-overflow: hidden;
  --cat-side-menu-link-flex-direction: column;
  --cat-side-menu-link-text-align: center;
  --cat-side-menu-icon-margin-inline-end: 0;
  --cat-side-menu-icon-margin-block-end: calc(var(--size-base-unit) * 0.5);
  --cat-side-menu-after-position: absolute;
  --cat-side-menu-after-top: -1px;
  --cat-side-menu-after-right: calc(var(--size-base-unit) * 0.5);
  --cat-side-menu-items-icon-display: none;
  --cat-side-menu-item-panel-position: absolute;
  --cat-side-menu-item-panel-background: var(--cat-theme-color-background-default);
  --cat-side-menu-item-panel-box-shadow: var(--cat-theme-box-shadow-md);
  --cat-side-menu-item-panel-border-radius: var(--cat-theme-border-radius);
  --cat-list-item-link-width: calc(100% - calc(var(--size-base-unit) * 0.5)); /* 2 */
  --cat-list-item-link-margin-inline-end: unset; /* 2 */
  --cat-side-menu-link-padding-block-start: calc(var(--size-base-unit) * 1.125);
  --cat-side-menu-link-padding-inline-end: calc(var(--size-base-unit) * 1.25);
  --cat-side-menu-link-padding-block-end: calc(var(--size-base-unit) * 1.125);
  --cat-side-menu-link-padding-inline-start: calc(var(--size-base-unit) * 1.25);
  --cat-side-menu-slotted-side-menu-link-padding-inline-start: calc(var(--size-base-unit) * 2);
  --cat-side-menu-slotted-list-min-width: 15rem;
  --cat-side-menu-item-margin-block-end: calc(var(--size-base-unit) * 1);
  --cat-side-menu-item-panel-list-item-body-margin-inline-start: 0;
  --cat-side-menu-item-panel-height: 70vh;
}
.cat-c-side-menu.cat-is-collapsed .cat-c-side-menu__nav {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}
.cat-c-side-menu.cat-is-collapsed:not(.cat-is-mobile) {
  --cat-list-item-link-padding-inline-end: calc(var(--size-base-unit) * 1.25);
}
.cat-c-side-menu.cat-is-collapsed.cat-is-mobile {
  display: var(--cat-side-menu-display, none);
}

.cat-c-side-menu.cat-is-mobile {
  --cat-list-item-link-hover-background: var(--cat-theme-color-content-strong-hover);
}

/**
  * height for sidemenu nav 
  **/
.cat-c-side-menu:not(.cat-is-collapsed) .cat-c-side-menu__nav {
  overflow-y: auto;
}
.cat-c-side-menu.cat-is-mobile .cat-c-side-menu__nav {
  background-color: var(--cat-theme-color-content-strong);
  min-height: 100%;
  max-height: 100%;
}

/**
 * Side menu list
 */
.cat-c-side-menu__list {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: visible;
}

/**
 * Side menu footer
 * 1) Slot for footer content to go into like legal text
 */
.cat-c-side-menu__footer {
  padding: calc(var(--size-base-unit) * 2);
  border-block-start: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
}

/**
 * Side menu header
 * 1) Slot for header content
 */
.cat-c-side-menu__header {
  margin-block-end: calc(var(--size-base-unit) * 2);
  padding: calc(var(--size-base-unit) * 2);
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-subtle);
}
`;
       